import React, { Component } from "react";
import { Helmet } from "react-helmet";
import PageWrapper from "../../components/PageWrapper/PageWrapper";
import Loading from "../../components/Loading/Loading";
import { withFirebase } from "../../components/Firebase/Firebase";
import CompetitionStageVoting from "./CompetitionStageVoting";
import CompetitionStageOpen from "./CompetitionStageOpen";
import CompetitionStageClosed from "./CompetitionStageClosed";
import CompetitionStageWinners from "./CompetitionStageWinners";
import ErrorPage from "../ErrorPage/ErrorPage";
import './Competition.css';
import {DefaultMetaTags} from "../../config";

class Competition extends Component {
  state = {
    id: null,
    error: false
  };
  async componentDidMount() {
    try {
      const id = await this.props.methods.getCompetitionBySlug(this.props.slug);
      this.setState({ id });
    } catch (error) {
      this.setState({ error: true });
    }
  }
  render() {
    // Competition couldn't be found
    if (this.state.error) {
      return <ErrorPage />;
    }
    // We haven't finished loading the competition yet
    if (!this.state.id) return <Loading />;

    const competitionData = this.props.competitions[this.state.id];
    const state = competitionData.state;
    let stateComponent;
    switch (state) {
      case "closed":
        stateComponent = (
          <CompetitionStageClosed competitionId={this.state.id} />
        );
        break;
      case "open":
        stateComponent = <CompetitionStageOpen competitionId={this.state.id} />;
        break;
      case "voting":
        stateComponent = (
          <CompetitionStageVoting competitionId={this.state.id} title="Finalists" />
        );
        break;
      case "winners":
        stateComponent = (
          <CompetitionStageWinners competitionId={this.state.id} />
        );
        break;
      default:
        stateComponent = null;
        break;
    }
    return (
      <PageWrapper context={`competition${state === 'open' ? '-entry' : ''}`}>
        <Helmet title={`Videos for Change | ${competitionData.name}`} />
        <DefaultMetaTags title={`Videos for Change | ${competitionData.name}`} />
        {stateComponent}
      </PageWrapper>
    );
  }
}

export default withFirebase(Competition);



// WEBPACK FOOTER //
// ./src/pages/Competition/Competition.js